// extracted by mini-css-extract-plugin
module.exports = {"container":"AdPlacement_container__tMolj","hasAlerts":"AdPlacement_hasAlerts___wntE"};